import "./single.css";
import parse from "html-react-parser";
import moment from "moment";
import { Link } from "react-router-dom";

const SinglePage = ({ post }) => {
  const vidurl = post.vid.split("=")[1];
  const date = new Date(post.date.seconds * 1000).getFullYear();
  return (
    <div>
      <div class="container">
        <h1 class="blog-title">{post.title}</h1>
        <p style={{ textTransform: "uppercase" }} className="meta">
          {post.cat} <br />
          {moment.unix(post.date.seconds).format("D MMMM YYYY [at] HH:mm")}
        </p>
        {/* <div class="meta">Posted {moment(post.date).fromNow()}</div> */}
        <img src={post.img} alt="" class="featured-img" />
        {post.vid && (
          <p style={{ width: "100%" }}>
            <iframe
              width="100%"
              height="315"
              src={`https://www.youtube.com/embed/${vidurl}?si=MzsWsfe6CARVCQgF`}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </p>
        )}{" "}
        <div class="content"> {post.desc ? parse(post.desc) : ""}</div>
      </div>
    </div>
  );
};

export default SinglePage;
